import { SDK } from '@redge-media/fo-js-sdk';
import { EventType, HeaderName, Platform, ProductType } from '@/shared/enums';
import ProductsMap from '@/shared/libs/sdk/products-map';
import { generateUUID } from '@/shared/utils/hash-code';
import getDeviceUID from '@/shared/utils/get-device-uid';

SDK.setup({
  httpOptions: {
    baseURL: `${window.location.origin}/api`,
    headers: {
      [HeaderName.APP_VERSION]: process.env.VUE_APP_VERSION,
      [HeaderName.DEVICE_UID]: getDeviceUID(),
    },
    params: {
      vodFilter: [],
    },
    withCredentials: true,
  },
  platform: Platform.BROWSER,
});

SDK.factory.update({
  types: ProductType,
  models: ProductsMap,
});

export default ({ $EventBus, $services }) => {
  const subscriber = $services.resolve('subscriber');

  SDK.apiAdapter.http.interceptors.request.use((config) => {
    config.headers[HeaderName.CORRELATION_ID] = generateUUID('client');
    config.params.lang = subscriber.currentLanguage;
    config.params.tenant = subscriber.currentTenant;

    return config;
  });

  SDK.apiAdapter.http.interceptors.response.use((response) => response, (error) => {
    if (error?.response?.status === 577) {
      $EventBus.emit(EventType.TECHNICAL_ERROR, error);
    }

    return Promise.reject(error);
  });
};
